/* TaxRates.tsx
	Une page affichant la gestion des taux de taxe
	Utilise le composant TaxRatesCrudCard pour lister, ajouter, éditer et supprimer les éléments
*/

// Import React
import React from 'react';

// Import FontAwesome
import { faPercent } from '@fortawesome/free-solid-svg-icons';

// Import Layout
import PageHeader from 'layout/PageHeader';

// Import Feature
import { TaxRatesCrudCard } from 'features/taxRate';

// Page TaxRates
const TaxRates: React.FC = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		<PageHeader
			icon={faPercent}
			title="Taux de taxe"
			subtitle="Gérez les taux de taxe applicables"
		/>
		<TaxRatesCrudCard size="lg" returnPath="/app/settings" className="mt-6" />
	</div>
);

export default TaxRates;
